import { useEffect, useRef } from 'react'
import './style.scss'

export interface EditTextAreaProps {
  placeholder: string
  value: string
  autoFocus?: boolean
  onChange: (value: string) => void
}

export function EditTextArea({ placeholder, value, autoFocus, onChange }: EditTextAreaProps) {
  const ref = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (autoFocus) {
      ref.current?.focus()
    }
  }, [])

  return (
    <textarea
      ref={ref}
      placeholder={placeholder}
      className='edit-text-area'
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  )
}
